import * as React from 'react'
import style from './DuplicatedJob.style'
import SuccessIcon from '../../../stories/atoms/Icons/deprecatedIcons/success'

type Props = {
  className?: string
}

const DuplicatedJob = ({ className }: Props) => {
  const css = cssClass => `${className || ''} ${cssClass}`

  return (
    <div className={css('flash-message')}>
      <div className={css('flash-message__inner')}>
        <div className={css('flash-message__icon')}>
          <SuccessIcon />
        </div>
        Vacature gedupliceerd
      </div>
    </div>
  )
}

DuplicatedJob.defaultProps = {
  className: '',
}
export { DuplicatedJob as RawDuplicatedJob }
export default style(DuplicatedJob)